import { IAssignee } from "@gtmhub/assignees";
import { IController, IComponentOptions } from "angular";
import { AvatarSize } from "../..";

interface IAssigneeChipBindings {
  assignee: IAssignee;
  size: AvatarSize;
  bolder: string;
  showTooltip: boolean;
  maxSymbolsToShow: number;
}

/**
 * @example <assignee-chip assignee="$ctrl.assignees[ownerId]" size="s-20" show-tooltip="true"></assignee-chip>
 * @param assignee IAssignee
 * @param size "s-20" | "s-22" | "s-24" | "s-26" | "s-70"
 * @param bolder string
 * @param showTooltip boolean
 * @param maxSymbolsToShow number
 */
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface AssigneeChipCtrl extends IAssigneeChipBindings {}
export class AssigneeChipCtrl implements IController {}

export const AssigneeChipComponent: IComponentOptions = {
  controller: AssigneeChipCtrl,
  templateUrl: require("./assignee-chip.jade"),
  transclude: true,
  bindings: {
    assignee: "<",
    size: "@",
    bolder: "<",
    showTooltip: "<",
    maxSymbolsToShow: "<",
  },
};
